"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kusudama = void 0;
const NoteType_1 = require("../lib/NoteType");
const CountableDrumrollNote_1 = require("../lib/CountableDrumrollNote");
class Kusudama extends CountableDrumrollNote_1.CountableDrumrollNote {
    constructor() {
        super(NoteType_1.NoteType.Kusudama);
    }
}
exports.Kusudama = Kusudama;
